// Client-safe uploads constants — no server dependencies
export const UPLOAD_PURPOSES = [
  "logo",
  "delivery_asset",
  "delivery_code",
  "support_image",
] as const;
export type UploadPurpose = (typeof UPLOAD_PURPOSES)[number];

export const ANY_MIME = "*/*" as const;

export const UPLOAD_LIMITS: Record<
  UploadPurpose,
  { maxBytes: number; mimes: readonly string[]; extensions?: readonly string[] }
> = {
  logo: {
    maxBytes: 5 * 1024 * 1024,
    mimes: ["image/png", "image/jpeg", "image/svg+xml", "image/webp"],
    extensions: ["png", "jpg", "jpeg", "svg", "webp"],
  },
  support_image: {
    maxBytes: 10 * 1024 * 1024,
    mimes: ["image/png", "image/jpeg", "image/webp", "image/gif"],
    extensions: ["png", "jpg", "jpeg", "webp", "gif"],
  },
  delivery_asset: {
    maxBytes: 50 * 1024 * 1024,
    mimes: [ANY_MIME],
  },
  delivery_code: {
    maxBytes: 500 * 1024 * 1024,
    mimes: ["application/zip", "application/x-zip-compressed"],
    extensions: ["zip"],
  },
};
